import { Typography, Box, Button, Alert, Grid2 as Grid } from '@mui/material';
import { FC } from 'react';
import { Add, Delete } from '@mui/icons-material';

import { JobseekerCreateDto } from '@libs/dto';
import { useForm } from '@carcareers/contexts';
import { TextInput } from '@carcareers/components';

export const AssociationsStep: FC = () => {
  const { data, setData } = useForm<JobseekerCreateDto>();
  const associations = data?.associations || [];

  const addAssociation = () => {
    const newAssociation = {
      name: '',
      description: '',
    };
    setData('associations', [...associations, newAssociation]);
  };

  const removeAssociation = (index: number) => {
    const updatedAssociations = associations.filter((_, i) => i !== index);
    setData('associations', updatedAssociations);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h5" component="h2" sx={{ mb: 2, fontWeight: 600 }}>
        Associations
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">Professional Associations</Typography>
        <Button startIcon={<Add />} onClick={addAssociation}>
          Add Association
        </Button>
      </Box>

      {associations.map((_, index) => (
        <Box key={index} sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="subtitle1">Association #{index + 1}</Typography>
            <Button startIcon={<Delete />} color="error" onClick={() => removeAssociation(index)}>
              Remove
            </Button>
          </Box>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextInput label="Association Name" name={`associations.${index}.name`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextInput label="Description" name={`associations.${index}.description`} multiline rows={3} fullWidth />
            </Grid>
          </Grid>
        </Box>
      ))}

      {associations.length === 0 && (
        <Alert severity="info">Professional associations and memberships are optional.</Alert>
      )}
    </Box>
  );
};

export default AssociationsStep;
